<style>
	#responseTable: {
		table-layout: fixed;
	}
	#editSwitchWrapper{
		width: 100%;
		position: relative;
		height: 50px;
	}
	#editSwitch{
		position: absolute;
		margin-bottom: 40px;
		right: 10px;
	}
</style>
<template>
	<div>
		<div id="editSwitchWrapper"  v-if="view == 'admin'" >
			<div id="editSwitch">
				<v-switch v-model="editable" label="Edit" color="success" right></v-switch>
			</div>
		</div>
		<div class="pa-3">
			<MwDataTable
				:columns="columns"
				:rows="rows"
				itemKey="row.id"
				:search="true"
				:editable="editable"
				:allowExport="true"
				v-on:update="update"
				:id="responseTable"
				>
			</MwDataTable>
			<p class="text-right">
			<v-dialog v-model="dialog47"  width="500">
				<template v-slot:activator="{ on }">
					<v-btn color="primary" dark v-on="on" >
					Filter Column Visability
					</v-btn>
				</template>
				<v-card>
					<v-card-title> Columns Visability </v-card-title>
					<v-card-text>
						<v-simple-table>
							<thead>
								<tr>
									<th width="60%">&nbsp;</th>
									<th>Show/Hide</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="header in headers" :key="header.value">
									<td>{{header.text}}</td>
									<td>
										<v-checkbox v-model="showHeaders" :indeterminate="showHeaders.length == 0" :value="header.value" ></v-checkbox>
									</td>
								</tr>
							</tbody>
						</v-simple-table>
					</v-card-text>

					<v-divider></v-divider>

					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="primary" text @click="dialog47 = false" > OK </v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			</p>
		</div>
		
	</div>
</template>
<script type="text/javascript">
	import Vue from 'vue';
	import Vuex from 'vuex';
	import MwDataTable from '../tools/MwDataTable.vue';
	
	import {visibleDisplayName} from "../../assets/permissionsFunctions.js"
	import {processSurveyColumns, processSurveyRows } from "../../assets/surveyProcessing.js";

	export default {
		name: "SurveyResponses", 
		props: {
			survey: { type: Object },
			project: {type: Object },
			limitParticipants: { type: Array },
		},
		data: () => {
			return {
				editable: false,
				showHeaders: []
			}
		},
		components:{
			MwDataTable: MwDataTable
		},
		computed: {
			...Vuex.mapState({
				view: state => state.auth.view,
				user: state => state.auth.user,
				responses: function(state){
					const self = this;
					var responses = state[state.auth.view].surveyResponses.filter( r => r.survey == self.survey.id )
					if( self.limitParticipants ){
						responses = responses.filter( response => {
							return self.limitParticipants.indexOf(response.respondent ) > -1  
						})
					}
					return responses
				},
				panelists: function(state){
					if( state.auth.view == 'admin' ){
						return state[state.auth.view].panelists
					}
					else{
						return state[state.auth.view].panelists
					}
				}
			}),
			headers(){
				let headers = [
					{value: "respondent", text: "Participant", inline: false}, 
					{value:"created", text: "Created", inline: false}
				];
				let questionHeaders = processSurveyColumns(this.survey.elements, this.editable);
				questionHeaders.forEach( h => h.width = "220px")
				questionHeaders = questionHeaders.filter( a => !a.excludeFromProfiles );
				headers = headers.concat( questionHeaders );
				return headers;
			}, 
			columns(){
				if( this.showHeaders.length ){
					let filters = this.showHeaders;
					return this.headers.filter( h => filters.indexOf(h.value) > -1 )
				}
				else{
					return this.headers;
				}
			},
			rows(){
				const self = this;
				let rows = processSurveyRows( self.responses, self.headers, self.editable );
				rows.forEach( row => {
					let respondent	= self.panelists.find( p => p.id ==  row.respondent);
					if( respondent ){
						row.respondent = visibleDisplayName(self.user, respondent, self.project );

					}
					if( row.created ){
						row.created = Vue.moment( row.created.toDate()).format("DD-MM-YYYY HH:mm") ;
					}
				})
				return rows;
			},
		}, 
		methods: {
			update(response, changedKey ){
				let update = {}
				update["data." + changedKey] = response[changedKey]
				this.$store.dispatch("updateDoc", {
					doc: "surveyResponses/" + response.id,
					data: update, 
					action: "update"
				})				
			}

		},
		watch: {
			survey: {
				immediate: true,
				handler: function(){
					this.$store.dispatch("fetchSurveyResponses", this.survey.id)
				}			
			}
		}, 
		destroyed( ){
			// this.$store.dispatch("unbindSurveyResponses")
		}
	}
</script>